import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, exhaustMap, map, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { SettingsOptionsService } from '../../settings-options/settings-options.service';
import { getSettingsOptionsCache, getSettingsOptionsCacheHit, getSettingsOptions, getSettingsOptionsSuccess, getSettingsOptionsError, updateSettingsOptions, updateSettingsOptionsSuccess, updateSettingsOptionsError } from './settings-options.actions';
import { settingsOptionsCacheFlag } from './settings-options.selectors';
import { State } from './settings-options.reducer';

@Injectable()
export class SettingsOptionsEffects {
  // Cache check effect - intercepts cache requests
  getSettingsOptionsCache$ = createEffect(() =>
    this.actions.pipe(
      ofType(getSettingsOptionsCache),
      withLatestFrom(this.store.select(settingsOptionsCacheFlag)),
      map(([action, cacheFlag]) =>
        cacheFlag
          ? getSettingsOptionsCacheHit()
          : getSettingsOptions()
      )
    )
  );

  // Actual API call effect
  getSettingsOptions$ = createEffect(() =>
    this.actions.pipe(
      ofType(getSettingsOptions),
      exhaustMap(() =>
        this.settingsOptionsService.getItems().pipe(
          map((response) =>
            getSettingsOptionsSuccess({
              settingsOptions: response,
            })
          ),
          catchError((err) => of(getSettingsOptionsError({ error: err })))
        )
      )
    )
  );

  updateSettingOption$ = createEffect(() =>
    this.actions.pipe(
      ofType(updateSettingsOptions),
      exhaustMap((action) =>
        this.settingsOptionsService.updateItem(action.option.id, action.option).pipe(
          map(response =>
            updateSettingsOptionsSuccess({
              option: response
            })
          ),
          catchError(err => of(updateSettingsOptionsError({error: err})))
        )
      )
    )
  );

  // Invalidate cache after successful update (force refresh)
  updateSettingOptionSuccess$ = createEffect(() =>
    this.actions.pipe(
      ofType(updateSettingsOptionsSuccess),
      map(() => getSettingsOptions())
    )
  );

  constructor(
    private actions: Actions,
    private store: Store<State>,
    private settingsOptionsService: SettingsOptionsService
  ) {}
}
